import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import styles from './sprite-selector-item-input.css';
class spriteSelectorItemInput extends React.Component {
    constructor (props){
        super(props);
        this.state = {};
    }
    render (){
        const {small, inputRef, ...componentProps} = this.props;
        return (
            <input
                {...componentProps}
                className={classNames(
                    styles.inputForm,
                    this.props.className,
                    {
                        [styles.inputSmall]: small
                    }
                )}
                ref={inputRef}
            />
        );
    }
}

spriteSelectorItemInput.propTypes = {
    className: PropTypes.string,
    inputRef: PropTypes.fun,
    small: PropTypes.bool
};

spriteSelectorItemInput.defaultProps = {
    small: false
};

export default spriteSelectorItemInput;
